<template>
  <div style="margin: 20px 120px">
    <div>
      <el-input type="textarea" v-model="formula" :autosize="{ minRows: 10, maxRows: 10 }">

      </el-input>
    </div>
    <!-- <div style="border: 1px solid red;"> {{ formula }}
    </div> -->
    <div class="rendered">
      <div v-html="md.render(formula)">

      </div>
    </div>


  </div>

</template>
<script>
import md from "@/utils/markdown/md";
import plotly from "@/components/echart/plotly.vue";

export default {
  data() {
    return {
      md,
      gs: '$$\\begin{matrix}0.8&0.2\\\\0.4&0.6\\\\\\end{matrix}$$',
      gs1: `**展开式子并利用基本不等式**：\n    - 对$\\frac{3}{2} \\times [2(a + 2) + (b - 4)] (\\frac{1}{a + 2} + \\frac{2}{b - 4})$进行展开：\n\r$$\\frac{3}{2} \\times [2(a + 2) \\times \\frac{1}{a + 2} + 2(a + 2) \\times \\frac{2}{b - 4} + (b - 4) \\times \\frac{1}{a + 2} + (b - 4) \\times \\frac{2}{b - 4}]$$\n$$=\\frac{3}{2} \\times (2 + \\frac{4(a + 2)}{b - 4} + \\frac{b - 4}{a + 2} + 2)$$\n$$=\\frac{3}{2} \\times (4 + \\frac{b - 4}{a + 2} + \\frac{4(a + 2)}{b - 4})$$\n\r   - 根据基本不等式$m + n \\geq 2\\sqrt{mn}$（当且仅当$m = n$时取等号），对于$\\frac{b - 4}{a + 2}$和$\\frac{4(a + 2)}{b - 4}$，有$\\frac{b - 4}{a + 2} + \\frac{4(a + 2)}{b - 4} \\geq 2\\sqrt{\\frac{b - 4}{a + 2} \\times \\frac{4(a + 2)}{b - 4}} = 4$。\n    - 所以$\\frac{3}{2} \\times (4 + \\frac{b - 4}{a + 2} + \\frac{4(a + 2)}{b - 4}) \\geq \\frac{3}{2} \\times (4 + 4) = 12$。
      `,
      gs2: `- 根据基本不等式$m + n \\geq 2\\sqrt{mn}$（当且仅当$m = n$时取等号），对于$\\frac{b - 4}{a + 2}$和$\\frac{4(a + 2)}{b - 4}$，有$\\frac{b - 4}{a + 2} + \\frac{4(a + 2)}{b - 4} \\geq 2\\sqrt{\\frac{b - 4}{a + 2} \\times \\frac{4(a + 2)}{b - 4}} = 4$。\n`,
      formula: "",
    }
  },
  components: {
    plotly,
  }
}
</script>
<style>
.rendered {
  overflow: auto;
  height: 600px;
}
</style>